import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ErrorPageContent from '@app/components/UI/ErrorPageContent/ErrorPageContent';

class ErrorBoundaryInner extends React.Component<{ navigate: any; location: any }, { hasError: boolean }> {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ hasError: true });
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location && this.state.hasError) {
			this.setState({ hasError: false });
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<ErrorPageContent />
			);
		}

		return this.props.children;
	}
}

export default function ErrorBoundary(props) {
	const navigate = useNavigate();
	const location = useLocation();

	return <ErrorBoundaryInner {...props} navigate={navigate} location={location} />;
}
